import { defineMessages } from 'react-intl';

export default defineMessages({
  native: { defaultMessage: 'Native' },
  pageTitle: { defaultMessage: 'Markets' },
  selectMarket: { defaultMessage: 'Select a market' },
  rewardsInformation: { defaultMessage: 'Rewards information' },
});
